// extracted by mini-css-extract-plugin
module.exports = {"pintxo-logo":"LogoHoC_pintxo-logo__dVKgK"};